import {
  GET_ACTIVE_CONTEST,
  GET_CONTEST,
  GET_CONTEST_BY_ID,
  GET_CONTEST_COMMENT_LIST,
  GET_CONTEST_ENTRY_LIST,
  GET_COMPLETE_CONTEST,
  GET_PROPOSED_CONTEST,
  GET_MYOREDR_CONTEST,
  GET_CONTEST_PUBLIC_COMMENT,
  GET_CONTEST_PROPOSAL_BY_ID,
  GET_CONTEST_CHILD_PUBLIC_COMMENT,
  GET_CONTEST_MODEL_COMMENT,
} from "../constants";

export const contest = (
  state = {
    getcontestpropsalbyid: {},
    getcontestpublicchildcommentlist: [],
    getcontestlist: [],
    myordercontestlist: [],
    getcontestbyid: [],
    getcontestentrylist: [],
    getproposalcontestlist: [],
    getcontestcommentlist: [],
    getcontestactivelist: [],
    getcontestcompletelist: [],
    getcontestmodelcommentlist: [],
  },
  action,
) => {
  switch (action.type) {
    case GET_CONTEST:
      return { ...state, getcontestlist: action.getcontestlist };
    case GET_CONTEST_PROPOSAL_BY_ID:
      return { ...state, getcontestpropsalbyid: action.getcontestpropsalbyid };
    case GET_CONTEST_BY_ID:
      return { ...state, getcontestbyid: action.getcontestbyid };
    case GET_CONTEST_ENTRY_LIST:
      return { ...state, getcontestentrylist: action.getcontestentrylist };
    case GET_CONTEST_COMMENT_LIST:
      return { ...state, getcontestcommentlist: action.getcontestcommentlist };
    case GET_ACTIVE_CONTEST:
      return { ...state, getcontestactivelist: action.getcontestactivelist };
    case GET_COMPLETE_CONTEST:
      return {
        ...state,
        getcontestcompletelist: action.getcontestcompletelist,
      };
    case GET_PROPOSED_CONTEST:
      return {
        ...state,
        getproposalcontestlist: action.getproposalcontestlist,
      };
    case GET_MYOREDR_CONTEST:
      return { ...state, myordercontestlist: action.myordercontestlist };
    case GET_CONTEST_PUBLIC_COMMENT:
      return {
        ...state,
        getcontestpubliccommentlist: action.getcontestpubliccommentlist,
      };
    case GET_CONTEST_CHILD_PUBLIC_COMMENT:
      return {
        ...state,
        getcontestpublicchildcommentlist:
          action.getcontestpublicchildcommentlist,
      };
    case GET_CONTEST_MODEL_COMMENT:
      return {
        ...state,
        getcontestmodelcommentlist: action.getcontestmodelcommentlist,
      };
    default:
      return state;
  }
};
